import React from 'react';
import classNames from 'classnames';

export default function GoalSplitRows({ goals = [], twoCol = false }) {
  if (!goals.length) return null;

  return (
    <div
      className={classNames(
        'bmc-page-goals-split',
        twoCol && 'bmc-page-goals-split--two-col',
      )}
      aria-label="Sustainability goals (square + text)"
    >
      {goals.map((goal) => (
        <div key={goal.key} className="bmc-page-goals-split-item">
          <div
            className={classNames(
              'bmc-page-goals-split-item-square',
              goal.colorClass,
            )}
          >
            {goal.title}
          </div>
          <div className="bmc-page-goals-split-item-text custom-font-body">
            {goal.description}
          </div>
        </div>
      ))}
    </div>
  );
}
